import { useCallback } from 'react';

type UseClipboard = {
  readText: () => Promise<string | null>;
  writeText: (value: string) => Promise<boolean>;
};

export function useClipboard(): UseClipboard {
  const readText = useCallback(async () => {
    if (
      typeof navigator === 'undefined' ||
      typeof navigator.clipboard?.readText !== 'function'
    ) {
      return null;
    }

    try {
      return await navigator.clipboard.readText();
    } catch {
      // Clipboard access can be denied by browser permissions.
      return null;
    }
  }, []);

  const writeText = useCallback(async (value: string) => {
    if (
      typeof navigator === 'undefined' ||
      typeof navigator.clipboard?.writeText !== 'function'
    ) {
      return false;
    }

    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // Clipboard access can be denied by browser permissions.
      return false;
    }
  }, []);

  return {
    readText,
    writeText,
  };
}
